import { APPOINTMENT_DIALOG_VARIANT } from '@/config'
import { useAppointmentDialog, type AppointmentDialogProps } from './useAppointmentDialog'
import { resolveAppointmentDialogVariant } from './variants/registry'

export type { AppointmentDialogProps } from './useAppointmentDialog'

const VariantComponent = resolveAppointmentDialogVariant(APPOINTMENT_DIALOG_VARIANT)

export function AppointmentDialog(props: AppointmentDialogProps) {
	const state = useAppointmentDialog(props)
	return <VariantComponent {...state} />
}
